import { render } from "./Edition2023View.vue?vue&type=template&id=3c2fc9d2"
import script from "./Edition2023View.vue?vue&type=script&lang=js"
export * from "./Edition2023View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__